import React, { Component } from 'react';

import FirstName from '../FirstName';
import LastName from '../LastName';
import Address from '../Address';
import DateofBirth from '../DateOfBirth';
import SSN from '../SSN';
import AcceptTerms from '../AcceptTerms';

import WidgetPropTypes from '../types';
import Button from '../../../components/UI/Button/index.tsx';
import css from '../ProvePrefill/ProvePrefill.module.scss';
import { terms } from '../Images';

export const WIDGET_NAME = 'prove_review';

class ProveEditInfo extends Component {
  constructor() {
    super();

    this.state = {
      answers: {
        setLegalFirstName: '',
        setLegalLastName: '',
        setLegalAddress: {},
        setUserDateOfBirth: '',
        setUserSsnLast4: '',
        acceptTerms: ''
      },
      enableNextButton: {
        setLegalFirstName: false,
        setLegalLastName: false,
        setLegalAddress: false,
        setUserDateOfBirth: false,
        setUserSsnLast4: false,
        acceptTerms: false
      }
    };
  }

  setPrefillAnswers() {
    const prefillAnswers = this.props.app.prefilledAnswers;
    if (prefillAnswers) {
      let enableNextButtonWithPrefill = this.state.enableNextButton;
      let answersWithPrefill = this.state.answers;
      // eslint-disable-next-line no-restricted-syntax
      for (const [question, answer] of Object.entries(prefillAnswers)) {
        if (Object.keys(this.state.answers).indexOf(question) !== -1) {
          enableNextButtonWithPrefill = {
            ...enableNextButtonWithPrefill,
            [question]: true
          };
          answersWithPrefill = {
            ...answersWithPrefill,
            [question]: answer
          };
        }
      }
      this.setState({
        enableNextButton: enableNextButtonWithPrefill,
        answers: answersWithPrefill
      });
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.segment.page('Registration', 'Prove Edit Info');
    this.setPrefillAnswers();
  }

  componentDidUpdate(prevProps, prevState) {
    const { widget, shouldEnable } = this.props;
    if (this.state !== prevState) {
      shouldEnable(widget, true);
    }
  }

  onAnswerChanged = (question, answer) => {
    // eslint-disable-next-line prefer-destructuring
    const answers = this.state.answers;
    answers[question] = answer;
    this.setState({ answers });
  };

  onEnableChanged = (question, enabled) => {
    const existingEnableNextButton = this.state.enableNextButton;
    existingEnableNextButton[question] = enabled;

    this.setState({ enableNextButton: existingEnableNextButton });
  };

  submitEdit = async () => {
    try {
      await Promise.all(
        [
          'setLegalFirstName',
          'setLegalLastName',
          'setLegalAddress',
          'setUserDateOfBirth',
          'setUserSsnLast4',
          'acceptTerms'
        ].map(ref => {
          if (
            this.refs[ref] &&
            typeof this.refs[ref].errorChecking === `function`
          ) {
            return this.refs[ref].errorChecking();
          }
          return false;
        })
      );
      this.props.analytics.trackEvent('Prove Data Edited', {
        eventProps: {
          data: 'address'
        }
      });
      // Save SSN to state so it can be used for answering KYC, unneccessary after NET-2031 is completed
      this.props.onSetSsn(this.state.answers.setUserSsnLast4);
      this.props.answer({
        accessToken: this.props.app.registrationToken,
        questions: [WIDGET_NAME],
        answers: [
          {
            reviewedInfo: true,
            firstName: this.state.answers.setLegalFirstName,
            lastName: this.state.answers.setLegalLastName,
            addressList: [this.state.answers.setLegalAddress],
            dob: this.state.answers.setUserDateOfBirth,
            last4: this.state.answers.setUserSsnLast4
          }
        ]
      });
      this.props.clearError();
    } catch (error) {
      window.scrollTo(0, 0);
    }
  };

  nextButtonDisabled = () =>
    // return true and disable next button if any keys inside enableNextButton are false
    Object.keys(this.state.enableNextButton).some(
      k => !this.state.enableNextButton[k]
    );

  render() {
    return (
      <div>
        <h1 data-e2e="prove-prefill-edit-header">Edit your information</h1>
        <FirstName
          {...this.props}
          ref={'setLegalFirstName'}
          widget={'setLegalFirstName'}
          shouldEnable={this.onEnableChanged}
          changeAnswerValue={this.onAnswerChanged}
        />
        <LastName
          {...this.props}
          ref={'setLegalLastName'}
          widget={'setLegalLastName'}
          shouldEnable={this.onEnableChanged}
          changeAnswerValue={this.onAnswerChanged}
        />
        <Address
          {...this.props}
          ref={'setLegalAddress'}
          widget={'setLegalAddress'}
          shouldEnable={this.onEnableChanged}
          changeAnswerValue={this.onAnswerChanged}
        />
        <DateofBirth
          {...this.props}
          ref={'setUserDateOfBirth'}
          widget={'setUserDateOfBirth'}
          shouldEnable={this.onEnableChanged}
          changeAnswerValue={this.onAnswerChanged}
        />
        <SSN
          {...this.props}
          ref={'setUserSsnLast4'}
          widget={'setUserSsnLast4'}
          shouldEnable={this.onEnableChanged}
          changeAnswerValue={this.onAnswerChanged}
        />
        <AcceptTerms
          app={this.props.app}
          toggles={this.props.toggles}
          changeAnswerValue={this.onEnableChanged}
          shouldEnable={this.onEnableChanged}
          widget={'acceptTerms'}
        />
        <Button
          text="Save and Continue"
          loading={this.props.app.loading}
          onClick={this.submitEdit}
          disabled={this.nextButtonDisabled()}
          changeAnswerValue={this.onAnswerChanged}
        />
        <p
          onClick={this.props.reviewInfo}
          className={css.provePrefillSecondaryButton}
        >
          Cancel
        </p>
        {terms.legalText}
      </div>
    );
  }
}

ProveEditInfo.propTypes = {
  changeAnswerValue: WidgetPropTypes.changeAnswerValue.isRequired,
  index: WidgetPropTypes.index.isRequired,
  onClick: WidgetPropTypes.onClick.isRequired,
  shouldEnable: WidgetPropTypes.shouldEnable.isRequired,
  widget: WidgetPropTypes.widget.isRequired,
  analytics: WidgetPropTypes.analytics.isRequired
};

export default ProveEditInfo;
